import { NgModule } from '@angular/core'
import { RouterModule } from '@angular/router'
import { CollectionsResolver } from '../collections/collections.resolver'
import { EntityHubSmartComponent } from '../entity-hub/entity-hub-smart.component'
import { SegmentTagMap } from '../shared/analytics/models/segment-tag-map.model'
import { TeamsListResolver } from './teams-list.resolver'
import { TEAMS_LIST_SEGMENT_TAG, TeamsListComponent } from './teams-list/teams-list.component'
import { EmptyTab } from '../events/components/event-detail/event-tabs/empty-tab/empty-tab.component'

@NgModule({
  imports: [
    RouterModule.forChild([
      {
        path: '',
        component: TeamsListComponent,
        data: {
          shouldShowEventTicker: true,
          segment: TEAMS_LIST_SEGMENT_TAG
        },
        resolve: { teams: TeamsListResolver }
      },
      {
        path: ':nodeId',
        component: EntityHubSmartComponent,
        resolve: { collection: CollectionsResolver },
        children: [
          {
            path: '',
            component: EmptyTab,
            data: {
              shouldShowAdSkin: false,
              noTopScroll: true,
              shouldShowEventTicker: true,
              segment: SegmentTagMap.COLLECTIONS_TAB_VIEW
            }
          },
          {
            path: ':tab',
            component: EmptyTab,
            data: {
              shouldShowAdSkin: false,
              noTopScroll: true,
              shouldShowEventTicker: true,
              segment: SegmentTagMap.COLLECTIONS_TAB_VIEW
            }
          }
        ],
        data: {
          shouldShowAdSkin: false,
          shouldShowEventTicker: true,
          segment: SegmentTagMap.COLLECTIONS_VIEW
        }
      }
    ])
  ],
  exports: [RouterModule]
})
export class TeamsRoutingModule {}
